export const en = {
    'actuality-author': 'Author',
    'actuality-links-title': 'Where to find up-to-date information',
    'actuality-obsolete': 'Page marked as outdated',
    'actuality-page-is-actual': 'Page is up-to-date',
    'actuality-page-is-obsolete': 'Page is outdated',
    'actuality-possibly-obsolete': 'The page has not been updated for a long time and the information may be outdated.',
    'actuality-show-more': 'Learn more',
    'button-cancel': 'Close',
    'button-publish': 'Publish',
    'button-save': 'Save',
    'convert-message-cancel': 'Cancel',
    'convert-message-confirm-body': 'After conversion, the page will only be available in the new editor, as this process is irreversible. Dynamic blocks created in the old editor behave differently in the new one and will require manual adjustments after conversion.',
    'convert-message-confirm-cancel': 'Cancel',
    'convert-message-confirm-submit': 'Convert',
    'convert-message-confirm-title': 'You are about to convert the page',
    'convert-message-help': 'Conversion only affects static blocks, so any tables of contents, dynamic tables, framed objects, and HTML code blocks will require manual adjustments after conversion',
    'convert-message-old-page': 'Compare to original',
    'convert-message-preview': 'Preview converted page',
    'convert-message-submit': 'Convert',
    'delete-redirect': 'Restore',
    'error-action-general': 'Refresh page',
    'error-action-not-found': 'Create page',
    'error-description-general': 'Try refreshing the page or contact support.',
    'error-description-not-found': 'This address is free. You can create a new page here.',
    'error-get-revision': 'Couldn\'t load the page version',
    'error-get-revisions': 'Couldn\'t load the list of versions',
    'error-merge-content': 'Copy your changes to the clipboard, refresh the page, and try to reenter them',
    'error-merge-title': 'Unable to merge changes',
    'error-merge-unknown-revision': 'Internal error. Copy your changes to the clipboard, refresh the page, and try to reenter them.',
    'error-moved-pages': 'Pages previously located at this address have been moved:',
    'error-title-general': 'Something went wrong',
    'error-title-not-found': 'There\'s nothing at this address',
    'error-translate': 'Couldn\'t translate page',
    'error-update-content': 'Couldn\'t save page',
    'error-update-is-collab': 'Error updating the Collab mode setting',
    'error-update-redirect': 'Could not update redirection',
    'merge-confirm-message': 'Someone made changes to this page while you were editing it. Merge the changes?',
    'message-edit': 'Edit',
    'message-edit-old-revision': 'You are editing an outdated version of the page. If you save your changes, the edited version of the page will become the current version. ',
    'redirect-from-message': 'You were redirected from',
    'redirect-page-message': 'This is a redirect page. It cannot be edited. You can restore it by deleting the redirection',
    'revision-message-author': 'Author',
    'revision-message-edit-current': 'Return to this version',
    'revision-message-last': 'Go to the current version',
    'revision-message-old-editor': 'is unavailable for editing after conversion for the new editor',
    'revision-message-old-editor-from': 'This page version dated',
    'revision-message-old-version': 'This is an outdated version of the page',
    'revision-message-old-version-from': 'This is an outdated version of the page from',
    'service-is-readonly-content': 'Editing is temporarily unavailable due to maintenance',
    'service-is-readonly-title': 'Editing is temporarily unavailable due to maintenance',
    'success-update-content': 'Page saved',
    'success-update-is-collab': 'Collab mode setting updated',
    'success-update-redirect': 'Redirection updated successfully'
};
